<template>
  <div class="pricing-mobile">
    <div v-if="trialPackage" class="pricing-mobile__item">
      <div class="pricing-mobile__header">
        <h4>{{ trialPackage.name }}</h4>
        <p class="price" v-if="paymentIsActive">
          {{ resource[`pricing.freeText`] }}
          <span class="price-type"
            >&nbsp;/ {{ resource["pricing.free.table"] }}</span
          >
        </p>
      </div>
      <div class="pricing-mobile__features">
        <div
          v-for="(feature, index) in trialPackage.features.slice(0, 5)"
          :key="index"
          :class="`pricing-mobile__feature ${
            feature.disabled ? 'pricing-mobile__feature--disabled' : ''
          }`"
        >
          <i
            :class="`icon-${feature.icon}`"
            :style="{
              color: feature.icon === 'tick-rounded' ? '#49ca77' : '#c3c3c3',
            }"
            style="font-size: 24px"
          />
          <div class="flex-grow-1">
            <p class="feature-name">{{ feature.name }}</p>
            <p class="feature-subheader">{{ feature.subHeader }}</p>
          </div>
          <div
            :id="`feature-tooltip-${trialPackage.packageId}-${index}-${type}`"
          >
            <i
              class="icon-info ml-1"
              v-if="feature.tooltip"
              style="color: #878787; font-size: 18px"
            />
          </div>
          <b-tooltip
            :target="`feature-tooltip-${trialPackage.packageId}-${index}-${type}`"
            placement="right"
            :delay="{ show: 250, hide: 200 }"
            custom-class="feature-tooltip-mobile"
          >
            {{ feature.tooltip }}
          </b-tooltip>
        </div>
        <b-collapse v-model="openFeatures[3]" class="w-100">
          <div id="collapse-text-trialPackage">
            <div
              v-for="(feature, featureIndex) in trialPackage.features.slice(5)"
              :key="featureIndex"
              :class="`pricing-mobile__feature ${
                feature.disabled ? 'pricing-mobile__feature--disabled' : ''
              }`"
            >
              <i
                :class="`icon-${feature.icon}`"
                :style="{
                  color:
                    feature.icon === 'tick-rounded' ? '#49ca77' : '#c3c3c3',
                }"
                style="font-size: 24px"
              />
              <div class="flex-grow-1">
                <p class="feature-name">{{ feature.name }}</p>
                <p class="feature-subheader">{{ feature.subHeader }}</p>
              </div>
              <div
                :id="`feature-tooltip-${trialPackage.packageId}-${featureIndex}-${type}-collapse`"
              >
                <i
                  class="icon-info ml-1"
                  v-if="feature.tooltip"
                  style="color: #878787; font-size: 18px"
                />
              </div>
              <b-tooltip
                :target="`feature-tooltip-${trialPackage.packageId}-${featureIndex}-${type}-collapse`"
                placement="right"
                :delay="{ show: 250, hide: 200 }"
                custom-class="feature-tooltip-mobile"
              >
                {{ feature.tooltip }}
              </b-tooltip>
            </div>
          </div>
        </b-collapse>
        <span
          @click="handleToggle(3)"
          :aria-controls="`collapse-text-feature-3`"
          :aria-expanded="openFeatures[3] || false"
          class="more-features"
        >
          {{
            openFeatures[3] ? resource["seeLessText"] : resource["seeMoreText"]
          }}
        </span>
      </div>
      <div class="pricing-mobile__footer">
        <button
          @click="
            loading || !trialPackage.enabled
              ? {}
              : paymentServiceHandler(trialPackage)
          "
          type="button"
          :class="`w-100 gap-1 border-button-pricing ${
            loading || !trialPackage.enabled ? 'disabled-btn' : ''
          }`"
          :id="`package-${trialPackage.packageId}-${type}-free`"
        >
          {{
            paymentIsActive
              ? resource["pricing.FreePlanButton"]
              : resource["pricing.contactUsButton"]
          }}
        </button>
        <b-tooltip
          v-if="(!trialPackage.enabled || !isAuth) && paymentIsActive"
          :target="`package-${trialPackage.packageId}-${type}-free`"
          placement="bottom"
          :delay="{ show: 250, hide: 200 }"
          custom-class="feature-tooltip-mobile"
        >
          {{
            !isAuth
              ? resource["pricing.LogoutPayNowTooltipText"]
              : currentPackage.trialPackageIsUsed
              ? resource["freePlanAlreadyUsed"]
              : resource["packageAnotherPlan"]
                  .replace("{name}", currentPackage.activeMainPackage)
                  .replace(
                    "{type}",
                    resource[
                      `pricing.${currentPackage.activeMainPackageInterval}.table`
                    ]
                  )
          }}
        </b-tooltip>
      </div>
    </div>

    <div
      v-for="(item, itemIndex) in items"
      :key="itemIndex"
      :class="[
        'pricing-mobile__item',
        item.isPopular ? 'pricing-mobile__item--popular' : '',
      ]"
    >
      <div v-if="item.isPopular" class="popular-tag">
        {{ resource["pricingPopularText"] }}
      </div>
      <div class="pricing-mobile__header">
        <h4>{{ item.name }}</h4>
        <p v-if="type === 'yearly' && paymentIsActive" class="saving-text">
          {{ resource["pricingSavingText"] }} {{ (item.unitAmount / 10) * 2 }}
        </p>
        <p class="price" v-if="paymentIsActive">
          €{{ item.unitAmount }}
          <span class="price-type"
            >&nbsp;/ {{ resource[`pricing.${item.type}.table`] }}</span
          >
        </p>
      </div>
      <div class="pricing-mobile__features">
        <div
          v-for="(feature, index) in item.features.slice(0, 5)"
          :key="index"
          :class="`pricing-mobile__feature ${
            feature.disabled ? 'pricing-mobile__feature--disabled' : ''
          }`"
        >
          <i
            :class="`icon-${feature.icon}`"
            :style="{
              color: feature.icon === 'tick-rounded' ? '#49ca77' : '#c3c3c3',
            }"
            style="font-size: 24px"
          />
          <div class="flex-grow-1">
            <p class="feature-name">{{ feature.name }}</p>
            <p class="feature-subheader">{{ feature.subHeader }}</p>
          </div>
          <div :id="`feature-tooltip-${item.packageId}-${index}-${type}`">
            <i
              class="icon-info ml-1"
              v-if="feature.tooltip"
              style="color: #878787; font-size: 18px"
            />
          </div>
          <b-tooltip
            :target="`feature-tooltip-${item.packageId}-${index}-${type}`"
            placement="left"
            :delay="{ show: 250, hide: 200 }"
            custom-class="feature-tooltip-mobile"
          >
            {{ feature.tooltip }}
          </b-tooltip>
        </div>
        <b-collapse v-model="openFeatures[itemIndex]" class="w-100">
          <div :id="`collapse-text-${itemIndex}`">
            <div
              v-for="(feature, featureIndex) in item.features.slice(5)"
              :key="featureIndex"
              :class="`pricing-mobile__feature ${
                feature.disabled ? 'pricing-mobile__feature--disabled' : ''
              }`"
            >
              <i
                :class="`icon-${feature.icon}`"
                :style="{
                  color:
                    feature.icon === 'tick-rounded' ? '#49ca77' : '#c3c3c3',
                }"
                style="font-size: 24px"
              />
              <div class="flex-grow-1">
                <p class="feature-name">{{ feature.name }}</p>
                <p class="feature-subheader">{{ feature.subHeader }}</p>
              </div>
              <div
                :id="`feature-tooltip-${item.packageId}-${featureIndex}-${type}-collapse`"
              >
                <i
                  class="icon-info ml-1"
                  v-if="feature.tooltip"
                  style="color: #878787; font-size: 18px"
                />
              </div>
              <b-tooltip
                :target="`feature-tooltip-${item.packageId}-${featureIndex}-${type}-collapse`"
                placement="left"
                :delay="{ show: 250, hide: 200 }"
                custom-class="feature-tooltip-mobile"
              >
                {{ feature.tooltip }}
              </b-tooltip>
            </div>
          </div>
        </b-collapse>
        <span
          @click="handleToggle(itemIndex)"
          :aria-controls="`collapse-text-feature-${itemIndex}`"
          :aria-expanded="openFeatures[itemIndex] || false"
          class="more-features"
        >
          {{
            openFeatures[itemIndex]
              ? resource["seeLessText"]
              : resource["seeMoreText"]
          }}
        </span>
      </div>
      <div class="pricing-mobile__footer">
        <button
          @click="loading || !item.enabled ? {} : paymentServiceHandler(item)"
          type="button"
          :class="`w-100 gap-1 ${
            loading || !item.enabled ? 'disabled-btn' : ''
          }`"
          :id="`package-${item.packageId}-${type}`"
        >
          {{
            paymentIsActive
              ? resource["pricing.ButtonLoggedUser"]
              : resource["pricing.contactUsButton"]
          }}
        </button>
        <b-tooltip
          v-if="(!item.enabled || !isAuth) && paymentIsActive"
          :target="`package-${item.packageId}-${type}`"
          placement="bottom"
          :delay="{ show: 250, hide: 200 }"
          custom-class="feature-tooltip-mobile"
        >
          {{
            !isAuth
              ? resource["pricing.LogoutPayNowTooltipText"]
              : item.packageId === currentPackage?.activeMainPackageId
              ? resource["packageDisableText"]
              : resource["packageAnotherPlan"]
                  .replace("{name}", currentPackage.activeMainPackage)
                  .replace(
                    "{type}",
                    resource[
                      `pricing.${currentPackage.activeMainPackageInterval}.table`
                    ]
                  )
          }}
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import AccountService from '@/services/account';
import hrvenueService from '../../../services/hrvenue.service';

export default {
  name: 'PricingTabItemMobile',

  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    trialPackage: {
      type: Object,
      required: true,
      default: () => {},
    },
    paymentIsActive: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    currentPackage: {
      type: Object,
      required: true,
      default: () => {},
    },
  },

  data() {
    return {
      loading: false,
      featuresData: this.trialPackage?.features || this.items[0].features,
      openFeatures: {},
      buttonLoading: false,
    };
  },

  computed: {
    isAuth() {
      return AccountService.checkAuth();
    },
  },

  methods: {
    async paymentServiceHandler(item) {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      if (this.isAuth) {
        if (!this.paymentIsActive) {
          this.$router.push({ name: 'ContactUs', params: { lang } });
          return;
        }
        this.loading = true;
        try {
          const response = await hrvenueService.paymentStart(item.packageId);
          if (response.checkoutUrl) {
            window.location.replace(response.checkoutUrl);
          } else if (response.checkoutId && !response.checkoutUrl) {
            window.location.reload();
          }
        } catch (error) {
          this.loading = false;
        }
      } else {
        this.$router.push({ name: 'RegisterView', params: { lang } });
      }
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'package_click',
        event_parameters: {
          choose_plan: `${item.type?.toLowerCase() || this.type}/${item.name?.toLowerCase()?.replaceAll(' ', '-')}`,
        },
        page_type: 'pricing',
        site_type: 'interview',
      });
    },

    handleToggle(index) {
      this.$set(this.openFeatures, index, !this.openFeatures[index]);
    },
  },
};
</script>

<style lang="scss">
@import "~@/style/starter.scss";

.pricing-mobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 16px;

  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
    border-radius: 12px;
    border: 1px solid #e5e5e5;
    background: #fff;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

    &--popular {
      box-shadow: 0px 0px 12px 5px rgba(255, 141, 6, 0.2);
      border: 2px solid #ff8d06;

      h4 {
        color: #ff8d06 !important;
      }
    }
    .popular-tag {
      background: #ffe9ce;
      display: flex;
      padding: 8px 0px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      align-self: stretch;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      min-height: 36px;

      color: #ff8d06;
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-weight: 500;
      line-height: 140%;
    }
  }
  &__header {
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-bottom: 1px solid #e5e5e5;

    h4 {
      color: #333;
      text-align: center;
      font-family: Roboto;
      font-size: 18px;
      font-weight: 700;
      line-height: 24px;
      margin-bottom: 0;
    }
    .saving-text {
      color: #878787;
      text-align: center;
      font-family: Roboto;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      margin-bottom: 0;
    }
    .price-type {
      color: #878787;
      text-align: center;
      font-family: Roboto;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      margin-bottom: 0;
    }
    .price {
      color: #333;
      font-family: Roboto;
      font-size: 22px;
      font-weight: 500;
      line-height: 28px;
      margin-bottom: 0;
    }
  }
  &__features {
    width: 100%;
    display: flex;
    padding: 24px 16px;
    flex-direction: column;
    align-items: flex-start;
  }
  &__feature {
    width: 100%;
    display: flex;
    align-items: center;
    align-self: stretch;
    margin-bottom: 8px;
    justify-content: space-between;
    gap: 8px;

    &--disabled {
      .feature-name {
        color: #878787 !important;
      }
    }

    .feature-name {
      color: #333;
      font-family: Roboto;
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
      margin-bottom: 0;
    }
    .feature-subheader {
      color: #878787;
      font-family: Roboto;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      margin-bottom: 0;
    }
  }
  &__footer {
    width: 100%;
    padding: 0 16px 16px;
  }
  .more-features {
    color: #ff8d06;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }
  button {
    display: flex;
    padding: 9px 16px;
    justify-content: center;
    align-items: center;
    border-radius: 44px;
    border: 0;
    background: #ff8d06;
    color: #fff;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;

    &.disabled-btn {
      background-color: #cccccc !important;
      color: #fff;
      cursor: not-allowed;
    }
  }
  .border-button-pricing {
    background: transparent !important;
    color: #ff8d06;
    border: 1px solid #ff8d06;

    &.disabled-btn {
      background: transparent !important;
      color: #ccc !important;
      border: 1px solid #cccccc !important;
      cursor: not-allowed;
    }
  }
}

.feature-tooltip-mobile {
  opacity: 1 !important;

  &.bs-tooltip-right {
    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17" fill="none"><path d="M9 0L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 15.5L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0L9 1.5L8 2.31994L2.22618 7.77299C1.80835 8.16761 1.80835 8.83239 2.22618 9.22701L8 14.6801L9 15.5Z" fill="%23E5E5E5"/></svg>');
        width: 9px;
        height: 17px;
      }
    }
  }

  &.bs-tooltip-left {
    .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17" fill="none"><path d="M9 0L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 15.5L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0L9 1.5L8 2.31994L2.22618 7.77299C1.80835 8.16761 1.80835 8.83239 2.22618 9.22701L8 14.6801L9 15.5Z" fill="%23E5E5E5"/></svg>');
        width: 9px;
        height: 17px;
        transform: rotate(180deg);
      }
    }
  }

  &.bs-tooltip-bottom {
    padding: 0 !important;
    top: 15px !important;

    .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17" fill="none"><path d="M9 0L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 15.5L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0L9 1.5L8 2.31994L2.22618 7.77299C1.80835 8.16761 1.80835 8.83239 2.22618 9.22701L8 14.6801L9 15.5Z" fill="%23E5E5E5"/></svg>');
        width: 9px;
        height: 17px;
        transform: rotate(90deg);
        bottom: 2px;
      }
    }
  }

  .tooltip-inner {
    background: #fff !important;
    border-radius: 4px !important;
    padding: 12px !important;
    width: 208px !important;
    box-shadow: 0px 2px 6px 0px rgba(176, 186, 197, 0.6);

    text-align: left;
    color: #333;
    /* Typography/Small Text/1 - Regular */
    font-family: Roboto;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
}
</style>
